// 塌房后 72 小时舆情时间线数据

export interface TimelinePhase {
  window: string;
  label: string;
  headline: string;
  description: string;
  signals: string[];
}

export const timelinePhases: TimelinePhase[] = [
  {
    window: "0–6h",
    label: "引爆期",
    headline: "爆料上线，热搜与粉丝同时涌入",
    description:
      "事件以图文或视频形式流出，热榜在短时间内快速攀升。最先受影响的是时刻在线的数据粉与前线站姐，粉圈内部从震惊转向互相求证，口径尚未统一。",
    signals: ["话题冲上热榜前排", "粉丝超话互问信源真假", "部分站姐开始设置账号仅自己可见"],
  },
  {
    window: "6–24h",
    label: "立场分化期",
    headline: "铁粉维护 vs 路人质疑，脱粉回踩初现",
    description:
      "官方与经纪公司的沉默或简短回应，让本就摇摆的粉丝开始站队。资深大粉试图稳定军心，路人则要求更多实锤；此时出现第一批删号取关，也有人连夜写起复盘帖。",
    signals: ["大粉维护帖与质疑帖并存", "消费与应援记录被翻出", "取关动作集中出现在早晚高峰"],
  },
  {
    window: "24–48h",
    label: "震荡期",
    headline: "后援会改口径，超话主持换血，回踩刷屏",
    description:
      "组织层面开始动荡：后援会声明措辞反复，超话主持人与会员矛盾公开化；回踩者晒出账目与旧料，情绪类长文大量出现，粉丝凝聚力进入最低谷。",
    signals: ["联合声明发布后又被删除", "超话主持人事后更替", "回踩与复盘内容占据广场"],
  },
  {
    window: "48–72h",
    label: "冷却重构期",
    headline: "热度回落，粉圈按立场完成三分",
    description:
      "讨论热度逐步降温，粉圈基本分化为继续支持、彻底脱粉、转为路人三股力量。应援组织暂停或重组，部分站子关停或转向考古向，新的内容秩序开始重建。",
    signals: ["热搜词条被新话题替代", "站子处置动作基本落地", "路人与老粉开始以作品视角复盘"],
  },
];